import React from 'react';

import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import KycDocument, { DropzoneMeta } from '@/pages/settings/verify/kyc-sections/KycDocument';
import KycDescription from '@/pages/settings/verify/kyc-sections/KycDescription';
import { selectKycDocumentPOP } from '@/store/selectors/kycSelectors';
import { KycType } from '@lucky7ventures/bff-types';
import { envIsSweden } from '@/constants/constants';
import { TranslatedRichText } from '@/components/TranslatedRichText';
import Accordion from '@/components/UI/Accordion';

const KycPOPHints = () => {
  const intl = useIntl();
  return (
    <div className="[&_button.accordion]:bg-black/[.02]">
      {!envIsSweden() && (
        <>
          <Accordion header={intl.formatMessage({ id: 'settings.verify.creditCard.header' })}>
            <TranslatedRichText id="settings.verify.creditCard.text" tagName="div" />
          </Accordion>
          <Accordion header={intl.formatMessage({ id: 'settings.verify.ewallet.header' })}>
            <TranslatedRichText id="settings.verify.ewallet.text" tagName="div" />
          </Accordion>
        </>
      )}
      <Accordion header={intl.formatMessage({ id: 'settings.verify.bankTransfer.header' })}>
        <TranslatedRichText id="settings.verify.bankTransfer.text" tagName="div" />
      </Accordion>
    </div>
  );
};

const KycPaymentMethod = ({ maxFiles = 1 }: { maxFiles?: number }) => {
  const pmDocument = useSelector(selectKycDocumentPOP);
  const intl = useIntl();

  if (!pmDocument) {
    return null;
  }

  const dropzoneMeta: DropzoneMeta = {
    id: KycType.PaymentMethod.toString(),
    minFiles: 1, // At least one file is needed for PM
    maxFiles,
    errorMessageTranslationKey: 'settings.verify.upload.error.imagesAndPdfOnly.text',
  };

  return (
    <KycDocument
      type={KycType.PaymentMethod}
      status={pmDocument.status}
      acceptedFileTypes={['image/png', 'image/jpeg', 'application/pdf']}
      title={intl.formatMessage({ id: 'settings.verify.paymentMethod.header' })}
      description={
        <>
          <KycPOPHints />
          <KycDescription kycType={KycType.PaymentMethod} />
        </>
      }
      dropzonesMeta={[dropzoneMeta]}
      validationErrorMessage={intl.formatMessage({
        id: 'settings.verify.submit.imagesAndPdfOnly.error',
      })}
      key={KycType.PaymentMethod}
    />
  );
};

export default KycPaymentMethod;
